const X_SFA_API_KEY_HEADER = 'X-Sfa-Api-Key';
const X_SFA_API_KEY = 'cr6by78num9m90tb7ec5';

const X_SFA_PASSWORD_HEADER = 'X-Fake-Password';

export { X_SFA_API_KEY_HEADER, X_SFA_API_KEY, X_SFA_PASSWORD_HEADER };
